@import "/src/styles/mixins.sass"

.list
    @include clickable-styled($outlined: true)
    cursor: auto
    display: flex

.item
    flex-grow: 1

.option
    @include label-large
    width: 100%
    height: 100%
    padding: 0.375rem 0.75rem
    // transition: background-color 0.2s cubic-bezier(0,.5,1,.5), color 0.2s cubic-bezier(0,.5,1,.5)

    &[disabled]
        color: var(--color-black-primary-disabled)
        pointer-events: initial
        cursor: not-allowed

    &.selected
        background-color: var(--color-black-primary)
        color: var(--color-white-primary)
        cursor: initial
